import React, { useState } from "react";
import styled from "styled-components";

import { useAppContext } from "@examspark/common-app";
import { Button, Modal, Toolbar, toast } from "@examspark/common-ui";
import { IconAddLine } from "@examspark/common-ui/dist/components/icons";
import { Classroom, ParsedExam, Unit } from "@examspark/types";

import { useMutationAddExamToClassroomBonfire } from "../../hooks/useQueries";
import { ClassroomUnitPicker } from "../common/ClassroomUnitPicker";

const StyledModalForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ExamAddToClassroomModal = (props: { exam: ParsedExam }) => {
  const addToClassroom = useMutationAddExamToClassroomBonfire();
  const [context] = useAppContext();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [unit, setUnit] = useState<Unit | null>(null);
  const [classroom, setClassroom] = useState<Classroom | null>(null);

  const appId = context.app?.id;
  const userId = context.user?.id;

  return (
    <>
      <Button
        title="Add to Classroom"
        color="create"
        onClick={() => setModalIsOpen(true)}
        icon={<IconAddLine />}
      >
        Add to Classroom
      </Button>
      <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)}>
        <Modal.PaddedBody>
          <StyledModalForm>
            <ClassroomUnitPicker
              unit={unit}
              onUnitChange={setUnit}
              classroom={classroom}
              onClassroomChange={setClassroom}
            />

            <Toolbar>
              <Toolbar.Right>
                <Button title="Cancel" onClick={() => setModalIsOpen(false)}>
                  Cancel
                </Button>
                <Button
                  title="Add to Classroom"
                  disabled={!unit || addToClassroom.isLoading}
                  isLoading={addToClassroom.isLoading}
                  color="create"
                  onClick={async () => {
                    if (
                      !classroom ||
                      !unit ||
                      !appId ||
                      !userId ||
                      !context.workspaceUser?.id
                    ) {
                      toast.error("Error adding to classroom");
                      console.error("Missing required params:", {
                        classroom,
                        unit,
                        appId,
                        userId,
                      });
                      return;
                    }

                    try {
                      await addToClassroom.mutateAsync({
                        exam: props.exam,
                        classroom,
                        unit,
                        name: props.exam.name ?? "Untitled Assessment",
                      });
                      toast.success("Assessment added to classroom");
                      setModalIsOpen(false);
                    } catch (e) {
                      console.error(e);
                      toast.error("Failed to add assessment to classroom");
                    }
                  }}
                >
                  Add to Classroom
                </Button>
              </Toolbar.Right>
            </Toolbar>
          </StyledModalForm>
        </Modal.PaddedBody>
      </Modal>
    </>
  );
};

export default ExamAddToClassroomModal;
